export default __webpack_public_path__ + "static/media/textutils_project-11.06410948.png";